module.exports = __webpack_public_path__ + "static/media/3_8.fb05c8ee.png";